import { Button, Link, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import FormComponent from 'modules/core/components/Form'
import FormRow from 'modules/core/components/FormRow'
import DeprecatedInputText from 'modules/core/components/Inputs/Text'
import PanesHeader from 'modules/core/components/PanesHeader'
import PanesPadForm from 'modules/core/components/PanesPadForm'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import {
  FormTypes,
  useEmployeePersonalProvider,
} from 'modules/employees/components/blocks/EmployeePersonalProvider'

interface Props {
  isCurrent: boolean
}

const Irpf = (props: Props) => {
  const { isCurrent } = props

  const { irpfForm: form, onSubmit } = useEmployeePersonalProvider()

  return (
    <PanesPadForm direction="horizontal" boxed>
      <PanesHeader
        description={i18n.tCurrent('hiring.irpf_description', isCurrent)}
        illustration="control-navigation-adjust-sound"
        title={i18n.t('common.irpf')}
      />
      <FormComponent>
        <FormRow>
          <DeprecatedInputText
            label={i18n.t('employee_form.irpf.label')}
            field={form.get('country_metadata.irpf_in_cents')}
          />
        </FormRow>
        {form.isDirty && (
          <>
            <FormRow>
              <Text.Normal>{i18n.t('employee_form.irpf.information')}</Text.Normal>
            </FormRow>
            <FormRow>
              <Link.Href target="_blank" href={buildUrl('/solicitud_irpf_superior.pdf')}>
                {i18n.t('employee_form.irpf.download_irpf_document')}
              </Link.Href>
            </FormRow>
            <FormRow footer>
              <Button onClick={() => onSubmit([FormTypes.IRPF])}>{i18n.t('common.submit')}</Button>
            </FormRow>
          </>
        )}
      </FormComponent>
    </PanesPadForm>
  )
}

export default observer(Irpf)
